<script setup lang="ts">
import type { Branches } from "~/types/directus-collections.d.ts";

const branch = useAttrs().branch as Branches;

// We are making this call the refreshing it because the server will not have the Auth Refresh cookie
// and the client will (if logged in), causing a mismatch in the data.
// Instead, we make the call twice, once on the server and once on the client, replacing the data on the client, overriding any differences
const { data: files } = await useAsyncData("branch_files", () =>
  useDirectus(
    readItems("branch_files", {
      fields: ["*", { file: ["*"] }],
      filter: {
        branch: { _eq: branch.id },
      },
      sort: "file_order",
    })
  )
);

const token = await useToken();

onMounted(() => {
  refreshNuxtData("branch_files");
});
</script>

<template>
  <CommonContainer tag="section" class="py-[--y-margin]">
    <div v-if="files?.length">
      <BranchFileItem v-for="file in files" :key="file.id" :file="file" :token="token"></BranchFileItem>
    </div>
    <div v-else class="text-center text-2xl font-semibold">No Files Found</div>
  </CommonContainer>
</template>
